import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { MobileBottomNavComponent } from "./mobile-bottom-nav.component";

@NgModule({
  declarations: [MobileBottomNavComponent],
  imports: [CommonModule, RouterModule],
  exports: [MobileBottomNavComponent],
})
export class MobileBottomNavModule {}
